export default "__VITE_ASSET__78HMjgx0__"